import React from 'react';
import {Container,  Flex, Text, Box, Link  } from '@chakra-ui/react';

import { grants } from "../DATABASE/researchGrants";

function ResearchGrants() {
    return (
    <>

        <Container maxW="1000px" py={5}>
            <Flex direction="column" align="left">
                <Text fontSize="25px" fontWeight="bold" textAlign="center">
                        Research Grants,{" "}
                    <Link href="/">
                        <Text as="span" color="blue.600" fontStyle="italic" fontWeight="bold" textDecoration="underline">
                            Dr. Burak Kantarci 
                        </Text>
                    </Link>
                </Text>
            </Flex>
        </Container>

        <Container maxW="800px" py={5} centerContent>
            {/* Header Section */}
            <Text fontSize="lg" fontWeight="bold" borderBottom="2px solid black" mb={4}>
                Research Grants and Funded Projects
            </Text>

            {/* Grants List */}
            {grants.map((grant, index) => (
                <Box 
                    key={index} 
                    p={4} 
                    borderWidth="1px" 
                    borderRadius="md" 
                    boxShadow="md" 
                    bg="white" 
                    w="100%" 
                    mt={3}
                >
                    {/* Title & Date Layout */}
                    <Flex justify="space-between" align="center" wrap="wrap">
                        <Text fontWeight="bold" flex="1" minW="60%">
                            {grant.title}
                        </Text>
                        <Text fontWeight="bold" fontStyle="italic" color="gray.600" minW="20%" textAlign="right">
                            {grant.date}
                        </Text>
                    </Flex>

                    {/* Description */}
                    <Text mt={2}>{grant.text}</Text>
                </Box>
            ))}
        </Container>
      
    </>
    );
  }


  export default ResearchGrants;